import { render, staticRenderFns } from "./qingjia_mng.vue?vue&type=template&id=1c8a46a7&scoped=true&"
import script from "./qingjia_mng.vue?vue&type=script&lang=js&"
export * from "./qingjia_mng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8a46a7",
  null
  
)

export default component.exports